import classNames from 'classnames';
import { FC } from 'react';
import ReactDOM from 'react-dom';

import Button from '@/components/button';

import styles from './styles.module.less';

interface NotificationProps {
  title: string;
  onConfirm?: () => void;
  onClose?: () => void;
}

const Notification: FC<NotificationProps> = ({ title, onClose, onConfirm }) => {
  return (
    <div
      className={classNames(styles.maskcontainer, {
        [styles.show]: true
      })}
    >
      <div className={styles.container}>
        <div className={styles.title}>{title}</div>
        <div className={styles.btn_box}>
          <Button
            className={styles.btn}
            onClick={onClose}
            color="linear-gradient(180deg, #DB5C3F, #AF402A)"
            style={{ padding: 0 }}
          >
            Cancelar
          </Button>
          <Button className={styles.btn} onClick={onConfirm} type="success" style={{ padding: 0 }}>
            Recarga
          </Button>
        </div>
      </div>
    </div>
  );
};

const Confirm: FC<NotificationProps> = ({ title, onClose, onConfirm }) => {
  return (
    <div
      className={classNames(styles.maskcontainer, {
        [styles.show]: true
      })}
    >
      <div className={styles.container}>
        <div className={styles.title}>{title}</div>
        <div className={styles.confirm_btn_box}>
          <Button className={styles.btn} onClick={onConfirm} type="success" style={{ padding: 0 }}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

class NotificationManager {
  notification: HTMLElement | null;
  confirm: HTMLElement | null;

  constructor() {
    this.notification = null; // 存储当前的通知元素
    this.confirm = null; // 存储当前的通知元素
  }

  open(props: NotificationProps) {
    this.close(); // 确保在打开新通知前关闭已有通知
    this.notification = document.createElement('div');
    document.body.appendChild(this.notification);
    const {
      title = '',
      onClose = typeof props?.onClose === 'function' ? props.onClose : this.close.bind(this),
      ...rest
    } = props;

    ReactDOM.render(<Notification title={title} onClose={onClose} {...rest} />, this.notification);
  }
  openConfirm(props: NotificationProps) {
    this.closeConfirm(); // 确保在打开新通知前关闭已有通知
    this.confirm = document.createElement('div');
    document.body.appendChild(this.confirm);
    const {
      title = '',
      onClose = typeof props?.onClose === 'function' ? props.onClose : this.closeConfirm.bind(this),
      ...rest
    } = props;

    ReactDOM.render(<Confirm title={title} onClose={onClose} {...rest} />, this.confirm);
  }

  close() {
    if (this.notification) {
      ReactDOM.unmountComponentAtNode(this.notification);
      document.body.removeChild(this.notification);
      this.notification = null;
    }
  }
  closeConfirm() {
    if (this.confirm) {
      ReactDOM.unmountComponentAtNode(this.confirm);
      document.body.removeChild(this.confirm);
      this.confirm = null;
    }
  }
}

// 创建一个全局的管理器实例
export const notify = new NotificationManager();
